import React, { FunctionComponent } from 'react';

import { propsHelperRem, SvgProps } from '@/shared/lib/propsHelper';

const Search: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4 11a5.9 5.9 0 1 1-11.8 0 5.9 5.9 0 0 1 11.8 0Zm-1.044 6.977a8.5 8.5 0 1 1 2.121-2.121l4.084 4.083-2.122 2.122-4.083-4.084Z"
            fill="#fff"
        />
    </svg>
);

export default Search;
